import {
  FormControl,
  Grid,
  TextField,
  TextareaAutosize,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as Redux from 'react-redux';
import ButtonFileMultipleImages from '../../../components/FieldFileMultilpleImages';
import LoadingComponent from '../../../components/Loading';
import { useNotification } from '../../../helpers/notification';
import { saveEntidadesAction } from '../EntidadesAction';
import BotonNuevoComponent from './BotonNuevo';
import FormEntidadesSchedule from './FormEntidadesSchedule';

const getScheduleChanges = (schedules) => {
  try {
    if (schedules && schedules.length > 0) {
      return schedules.map(({ id, blocks, ...s }) => ({
        ...s,
        blocks: blocks.map(({ id, ...b }) => b),
      }));
    }
    return [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

// Definir horarios por defecto (7 días con bloques de horario completo)
const defaultSchedules = Array.from({ length: 7 }, (_, i) => {
  return {
    day: i,
    blocks: [
      {
        start: '00:00:00',
        end: '23:59:59',
      },
    ],
  };
});

const FormDatosEntidad = ({ openModal = () => {}, onChanges }) => {
  const dispatch = Redux.useDispatch();
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const { addNotification } = useNotification();

  let activo = entidadesStore.activo;
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [initialData, setInitialData] = React.useState(null);
  const [entidad, setEntidad] = React.useState({
    description: '',
    mapUrl: '',
    aboutImages: [],
    deletedAboutImages: [],
    schedules: defaultSchedules,
  });

  React.useEffect(() => {
    if (activo === null) return;
    const data = {
      description: activo.description,
      mapUrl: activo.mapUrl,
      aboutImages: activo.images.aboutImages,
      newAboutImages: [],
      deletedAboutImages: [],
      schedules: activo.schedules ? getScheduleChanges(activo.schedules) : defaultSchedules,
    };
    setEntidad(data);
    setInitialData(JSON.stringify(data));
  }, [activo]);

  React.useEffect(() => {
    if (initialData) {
      const currentData = JSON.stringify(entidad);
      const hasChanges = currentData !== initialData;
      onChanges?.(hasChanges);
    }
  }, [entidad, initialData, onChanges]);

  const _handleSubmit = async () => {
    let data = {
      description: entidad.description,
      mapUrl: entidad.mapUrl,
      newAboutImages: entidad.newAboutImages,
      deletedAboutImages: entidad.deletedAboutImages,
      schedules: getScheduleChanges(entidad.schedules),
    };

    setLoadingSave(true);
    let res = await saveEntidadesAction(
      { dispatch, addNotification },
      data,
      {
        id: activo ? activo.id : null,
        isSU: true,
      },
      entidadesStore.params
    );
    if (res) {
      setInitialData(JSON.stringify(entidad));
      onChanges?.(false);
    }
    openModal(!res);
    setLoadingSave(false);
  };

  return (
    <Box component="form">
      <Grid container spacing={2} sx={{ mt: loadingSave ? 2 : 0 }}>
        <LoadingComponent
          isLoading={loadingSave}
          text={activo ? 'Actualizando...' : 'Guardando...'}
        />
        <Grid item xs={12} md={6}>
          <FormControl variant="standard" sx={{ width: '100%' }}>
            <Typography variant="body">Descripción</Typography>
            <TextareaAutosize
              size="small"
              type="time"
              value={entidad.description}
              minRows={3}
              onChange={(e) =>
                setEntidad({ ...entidad, description: e.target.value })
              }
              id="description"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl variant="standard" sx={{ width: '100%' }}>
            <Typography variant="body">URL del mapa</Typography>
            <TextField
              size="small"
              value={entidad.mapUrl}
              onChange={(e) =>
                setEntidad({ ...entidad, mapUrl: e.target.value })
              }
              id="mapUrl"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12}>
          <ButtonFileMultipleImages
            images={entidad.aboutImages}
            onChange={(files) => {
              setEntidad({ ...entidad, newAboutImages: files });
            }}
            onDelete={(image) => {
              setEntidad({
                ...entidad,
                deletedAboutImages: [...entidad.deletedAboutImages, image],
              });
            }}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <FormEntidadesSchedule
            edit
            onChange={(schedules) => {
              setEntidad({ ...entidad, schedules });
            }}
            data={entidad.schedules}
          />
        </Grid>

        <Grid item md={12} align="center" sx={{ p: 2 }}>
          <BotonNuevoComponent click={_handleSubmit} morado text="GUARDAR" />
        </Grid>
      </Grid>
    </Box>
  );
};

FormDatosEntidad.propTypes = {
  openModal: PropTypes.func,
  onChanges: PropTypes.func,
};

export default FormDatosEntidad;
